import { AlertsManager } from '@/components/analytics/AlertsManager';

export function AlertsView() {
  return <AlertsManager />;
}
